import { render, staticRenderFns } from "./RulePopUp.vue?vue&type=template&id=0ff2d922&"
import script from "./RulePopUp.vue?vue&type=script&lang=js&"
export * from "./RulePopUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports